import { render } from "./ConsumeList.vue?vue&type=template&id=71e3b0e5&scoped=true"
import script from "./ConsumeList.vue?vue&type=script&lang=js"
export * from "./ConsumeList.vue?vue&type=script&lang=js"

import "./ConsumeList.vue?vue&type=style&index=0&id=71e3b0e5&scoped=true&lang=scss"

import exportComponent from "D:\\由创科技-ljx\\apicode\\github\\DY.Web\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71e3b0e5"]])

export default __exports__